import React, { useMemo } from "react"
import { MemberDropdown } from "@pga/pga-component-library"
import { useCoachToolsProfilePhoto } from "../queries/profilePhoto"
import { mergeMemberDisplayPhoto } from "../../utils/memberPhoto"

const MemberDrop = ({
  me,
  loading,
  options,
  meEmailMigrationData,
  onToggleDoNotShowAgain,
}) => {
  const coachToolsProfilePhoto = useCoachToolsProfilePhoto()
  const displayMe = useMemo(
    () => mergeMemberDisplayPhoto(me, coachToolsProfilePhoto),
    [me, coachToolsProfilePhoto],
  )

  return (
    <MemberDropdown
      me={displayMe}
      loading={loading}
      options={options}
      meEmailMigrationData={meEmailMigrationData}
      onToggleDoNotShowAgain={onToggleDoNotShowAgain}
    />
  )
}

export default MemberDrop
